import { render } from "./PageLoading.vue?vue&type=template&id=28437807&scoped=true"
import script from "./PageLoading.vue?vue&type=script&lang=js"
export * from "./PageLoading.vue?vue&type=script&lang=js"

import "./PageLoading.vue?vue&type=style&index=0&id=28437807&lang=css"
import "./PageLoading.vue?vue&type=style&index=1&id=28437807&lang=scss&scoped=true"

import exportComponent from "/data/project/activity-v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28437807"]])

export default __exports__